<template>
  <section :class="page.ItemID == 'sjxRSWmuO' ? 'rounded':''" class="category">
    <div class="inner">
      <h1 class="category-heading">
        <page-link :to="'/' + page.url">{{page.name}}</page-link>
      </h1>
      <div class="category-grid">
        <a
          :key="item.ItemID"
          @click.prevent="showModal(item)"
          class="product-thumb"
          href
          v-for="item in productList"
          v-tooltip="{
            content: item.promo
          }"
        >
          <img :alt="item.name" :src="item.image" />

          <span class="product-thumb-title">{{item.name}}</span>
          <span
            class="product-thumb-price"
            v-if="item.options && item.options.length"
          >from &pound;{{ fromPrice(item.options) }}</span>
          <span class="product-thumb-view">
            <img alt="Configure and buy" src="../assets/ripple.svg" /> configure and buy
          </span>
        </a>
      </div>
    </div>

    <base-modal :show="show_modal" @close="show_modal = false">
      <h3>{{itemToView.name}}</h3>
      <div class="modal-grid">
        <div>
          <img :src="itemToView.image" class="limited" />
        </div>
        <div>
          <div v-html="itemToView.description"></div>
          <div class="add-to-basket">
            Select an option:
            <select v-model.lazy="itemOption">
              <option :key="option._id" :value="option" v-for="option in filteredOptions">{{option.name}}</option>
            </select>
            <button @click="addItem">Add to basket</button>
          </div>
        </div>
      </div>
    </base-modal>
  </section>
</template>

<script>
import { mapState } from "vuex"
export default {
  data() {
    return {
      itemToView: { options: [] },
      show_modal: false,

      itemOption: {}
    }
  },
  computed: {
    ...mapState(["page", "posts", "ironmongery", "treatments", "IDs"]),
    productList: function() {
      if (this.page.ItemID == this.IDs.postsID && this.posts)
        return this.posts.filter(p => p.available_on && p.available_on.includes(this.IDs.postsID))

      if (this.page.ItemID == this.IDs.ironmongeryID && this.ironmongery)
        return this.ironmongery.filter(i => i.available_on && i.available_on.includes(this.IDs.ironmongeryID))

      if (this.page.ItemID == this.IDs.treatmentsID && this.treatments)
        return this.treatments.filter(
          t =>
            t.options && t.options.filter(o => o.available_on && o.available_on.includes(this.IDs.treatmentsID)).length
        )

      return []
    },
    filteredOptions() {
      if (this.page.ItemID != this.IDs.treatmentsID) return this.itemToView.options
      return this.itemToView.options.filter(o => o.available_on && o.available_on.includes(this.page.ItemID))
    }
  },
  methods: {
    fromPrice(options) {
      if (!options.length) return
      var prices = options.filter(o => o.price).map(o => parseFloat(o.price))
      if (!prices.length) return
      prices.sort((a, b) => a - b)

      return prices[0].toFixed(2).replace(".00", "")
    },
    showModal(item) {
      this.itemToView = item
      this.show_modal = true
    },
    addItem() {
      if (this.itemOption._id) {
        var item_option = {
          ItemID: this.itemToView.ItemID,
          name: this.itemToView.name,
          price: parseFloat(this.itemOption.price),
          delivery: this.itemToView.delivery,
          qty: 1,
          product: {
            _id: this.itemOption._id,
            detail: this.itemOption.name,
            ItemID: this.itemToView.ItemID,
            name: this.itemToView.name
          }
        }

        if (this.page.ItemID == this.IDs.postsID) item_option.product_type = "post"
        if (this.page.ItemID == this.IDs.ironmongeryID) item_option.product_type = "ironmongery"
        if (this.page.ItemID == this.IDs.treatmentsID) item_option.product_type = "treatment"

        this.$store.commit("basket/addItem", item_option)
        this.$nextTick().then(() => {
          this.$router.push("basket")
        })

        // this.itemToView = {}
        // this.itemOption = {}

        // this.show_modal = false
      }
    }
  }
}
</script>

<style scoped>
.category {
  margin: 3rem 0;
  font-size: 1.5rem;
}

.category .inner {
  border: 1px solid #eaeaea;
  padding: 3rem 3%;
  padding-bottom: 2rem;
}

.category-more img {
  width: 2.5rem;
  display: inline-block;
  height: 2.5rem;
  margin-bottom: -0.5rem;
  margin-right: 0.5rem;
}

.category-more {
  display: block;
  max-width: 330px;
  text-align: center;
  color: white;
  background-color: #455051;
  padding: 0.5rem 1rem;
  font-size: 1.8rem;
  border-bottom: 5px solid #f79227;
  margin: 1.5rem auto;
}

.category-grid {
  display: table;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 5rem;
}

.modal-grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 4rem;
}

.modal-container img {
  max-height: 80vh;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .category-grid > * {
    width: 25%;
    padding-left: 1%;
    padding-right: 2%;
    float: left;
    min-height: 45rem;
  }
}

.product-thumb * {
  transition: all 0.4s;
}

.product-thumb > img {
  width: 95%;
  display: block;
  margin: auto;
}

.rounded img {
  border-radius: 100%;
}

.product-thumb span {
  display: block;
}

.product-thumb-title {
  font-size: 2rem;
  font-weight: bold;
  color: #414e4f;
  line-height: 1.5;
  margin-top: 1rem;
}

.product-thumb-price {
  font-size: 1.7rem;
  font-weight: bold;
  color: #f79227;
}

.product-thumb-view {
  margin-top: 10px;
  opacity: 0;
  background: #414e4f;
  color: white;
  text-align: center;
  padding: 0.5rem;
}

.product-thumb:hover .product-thumb-view {
  margin-top: 5px;
  opacity: 1;
}

.product-thumb:hover > img {
  transform: scale(1.05);
}

.product-thumb-view img {
  width: 2rem;
  display: inline-block;
  height: 2rem;
  margin-bottom: -0.5rem;
  margin-right: 0.5rem;
}

.add-to-basket {
  font-size: 2rem;
}
.add-to-basket select {
  padding: 0.5rem 1rem;
  font-size: 1.5rem;
  margin-right: 1rem;
  max-width: 35rem;
}
.add-to-basket button {
  padding: 0.5rem 1rem;
  font-size: 2rem;
  border: 0;
  background: #434f50;
  border-bottom: 5px solid #f79227;
  color: white;
  position: relative;
  cursor: pointer;
}
.limited {
  max-width: 30rem;
}

@media screen and (max-width: 750px) {
  .category-grid {
    display: table;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0rem 5rem;
  }
  .category-heading {
    margin-bottom: 3rem;
  }
  .product-thumb {
    text-align: center;
  }
  .modal-grid {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
  .limited {
    max-height: 20rem;
    margin: auto;
    display: block;
  }
}
</style>
